import React, { ReactNode, useEffect } from 'react';
import Head from 'next/head';
import Script from 'next/script';
import { translate } from 'infras/i18n';
import { imagePath } from 'presentations/assets';

interface Props {
  children?: ReactNode;
  title?: string | null;
  description?: string;
}

export default function DashboardDocument(props: Props) {
  const siteName = translate('siteName');
  const pageTitle = props.title ? `${props.title} | ${siteName}` : siteName;
  const description = props.description || '';

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="noindex" />
        <meta
          name="viewport"
          content="initial-scale=1.0, width=device-width, user-scalable=no"
        />
        <link
          rel="icon"
          type="image/x-icon"
          href={imagePath('icons/favicon.ico')}
        />
        <link
          rel="apple-touch-icon"
          href={imagePath('icons/icon-192x192.png')}
        />
        <link rel="dns-prefetch" href="//www.google-analytics.com" />
        <link rel="dns-prefetch" href="//widget.intercom.io" />
        <link rel="dns-prefetch" href="//js.intercomcdn.com" />
        <link rel="dns-prefetch" href="//connect.facebook.net" />
        <link rel="dns-prefetch" href="//www.jicoo.com" />
        {/* <link
          href="https://cdn1.codox.io/lib/2.x/css/wave.client.css"
          rel="stylesheet"
        /> */}
      </Head>
      {process.env['GA_TRACKING_ID'] && (
        <>
          <script
            src={`https://www.googletagmanager.com/gtag/js?id=${process.env['GA_TRACKING_ID']}`}
          />
          <Script
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
              __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${process.env['GA_TRACKING_ID']}',{
                custom_map: { 
                  dimension1: 'plan',
                }
              });
              window.dataLayer.push({'event': 'optimize.activate'});
              `,
            }}
          />
        </>
      )}
      {/* <Script
        src="https://cdn1.codox.io/lib/2.x/api/wave.client.js"
        type="text/javascript"
      /> */}
      {props.children}
    </>
  );
}
